import {Injectable} from '@angular/core';
import {
  DeliveryService,
  DeliveryTypeWithFee,
  DeliveryTypeWithFeePost,
  DeliveryTypeWithFeePut,
  FeePeriodPrice, FeePeriodPricePost
} from '../../generated/sales-terminal-client';
import {SnackService} from '../snack/snack.service';
import {Observable, tap} from 'rxjs';
import {finalize} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DeliveryTypeService {

  constructor(private deliveryService: DeliveryService,
              private snackService: SnackService) {}

  public getDeliveryTypes(expired: boolean): Observable<DeliveryTypeWithFee[]> {
    return this.deliveryService.getLandCentreDeliveryTypes(expired).pipe(
      tap({ error: (e) => this.snackService.showBackendError(e) })
    );
  }

  public updateDeliveryTypesOrder(newOrder: number[]): Observable<DeliveryTypeWithFee[]> {
    return this.deliveryService.updateDeliveryTypesOrder(newOrder).pipe(
      tap({ error: (e) => this.snackService.showBackendError(e) })
    );
  }

  public createDeliveryType(deliveryTypePost: DeliveryTypeWithFeePost): Observable<DeliveryTypeWithFee> {
    return this.deliveryService.createLandCentreDeliveryType(deliveryTypePost).pipe(
      tap({ error: (e) => this.snackService.showBackendError(e) })
    );
  }

  public updateDeliveryType(deliveryTypeId: number, deliveryTypePut: DeliveryTypeWithFeePut): Observable<DeliveryTypeWithFee> {
    return this.deliveryService.updateLandCentreDeliveryType(deliveryTypeId, deliveryTypePut).pipe(
      tap({ error: (e) => this.snackService.showBackendError(e) })
    );
  }

  public deleteDeliveryTypePeriodPrice(deliveryTypeId: number, periodPriceId: number): Observable<DeliveryTypeWithFee> {
    return this.deliveryService.deleteDeliveryTypePeriodPrice(deliveryTypeId, periodPriceId).pipe(
      tap({ error: (e) => this.snackService.showBackendError(e) })
    )
  }

  public updateDeliveryTypePeriodPrice(deliveryTypeId: number, periodPriceId: number, feePeriodPrice: FeePeriodPrice): Observable<DeliveryTypeWithFee> {
    return this.deliveryService.updateDeliveryTypePeriodPrice(deliveryTypeId, periodPriceId, feePeriodPrice).pipe(
      tap({ error: (e) => this.snackService.showBackendError(e) })
    )
  }

  public addDeliveryTypePeriodPrice(deliveryTypeId: number, periodPricePost: FeePeriodPricePost): Observable<DeliveryTypeWithFee> {
    return this.deliveryService.addDeliveryTypePeriodPrice(deliveryTypeId, periodPricePost).pipe(
      tap({ error: (e) => this.snackService.showBackendError(e) })
    )
  }
}
